
export const getAuthScopes = () => {
    const scopesEnv = process.env.REACT_APP_AUTH_SCOPES || '';
    // Split by comma and trim whitespace
    return scopesEnv.split(',').map(scope => scope.trim()).filter(scope => scope.length > 0);
  };
  